import React from 'react';

import { UiButton } from '../../ui/ui-button';

type Props = {
  disabled?: boolean;
  onPrev?: () => void;
  onSkip?: () => void;
  onNext?: () => void;
  editing: boolean;
  saving: boolean;
};

export class JobFlowButtons extends React.PureComponent<Props> {
  static defaultProps = {
    disabled: false,
    onNext: null,
  };

  render() {
    const { saving, editing, disabled, onSkip, onPrev, onNext } = this.props;

    return (
      <div className="u-margin-top-2x u-display-flex u-justifyContent-spaceBetween">
        <div>
          {!editing && onPrev && (
            <UiButton onClick={onPrev} variant="dismiss">
              Back
            </UiButton>
          )}
        </div>
        <div>
          {!editing && onSkip && (
            <UiButton onClick={onSkip} variant="dismiss">
              Skip For Now
            </UiButton>
          )}
          <UiButton
            type="submit"
            onClick={onNext}
            className="u-margin-left"
            loading={saving}
            disabled={disabled}
          >
            {editing ? 'Save' : 'Next'}
          </UiButton>
        </div>
      </div>
    );
  }
}
